<template>

  <div class="tr"  v-if="type==='default'&& !parent">
    <div class="th">{{element.label}}</div>
    <div class="td">{{users.map(mapper=>mapper.real_name).join(',')}}</div>
  </div>
  <template v-else-if="type==='excel'">
    <div class="th">{{element.label}}</div>
    <div class="td">{{users.map(mapper=>mapper.real_name).join(',')}}</div>
  </template>
  <span v-else>{{users.map(mapper=>mapper.real_name).join(',')}}</span>

</template>

<script>

import {mapStores} from "pinia";
import {useUserStore} from "@/stores/user";

export default {
  components: {},
  computed:{
    ...mapStores(useUserStore)
  },
  props: {
    form: {
      type: Object,
    },
    data: {
      type: Object,
    },
    element: {
      type: Object
    },
    parent: {
      type: Object
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      users:[],
    }
  },
  created() {


    if(this.data[this.element.id]){

      if(typeof  this.data[this.element.id] === 'string'){
        this.userStore.findById(this.data[this.element.id]).then(res=>{
          this.users  = [res.data];
        })
      }else{
        this.userStore.findByIds(this.data[this.element.id]).then(res=>{
          this.users  = res.data;
        })
      }


    }

  }
}

</script>

<style scoped lang="scss">

</style>